import { Component } from "react"
import posthog from "posthog-js"
import "./CostComparison.css"


class CostComparison extends Component {
    render() {
        return (
            <div className="cost-comparison">
                <a className="cost-comparison-row cost-comparison-bad cost-comparison-link" href="/blog/posts/why-irish-buyers-overpay/" target="_blank" rel="noopener noreferrer"
                    onClick={() => posthog?.capture("blog_link_clicked", { source: "cost_comparison", post: "why-irish-buyers-overpay" })}>
                    <span className="cost-comparison-label">Uninformed buyers overpay by</span>
                    <span className="cost-comparison-value">4% – 15%</span>
                </a>
                <a className="cost-comparison-row cost-comparison-bad cost-comparison-link" href="/blog/posts/why-irish-buyers-overpay/" target="_blank" rel="noopener noreferrer"
                    onClick={() => posthog?.capture("blog_link_clicked", { source: "cost_comparison", post: "why-irish-buyers-overpay" })}>
                    <span className="cost-comparison-label">Uninformed sellers lose</span>
                    <span className="cost-comparison-value">3.7%</span>
                </a>
                <div className="cost-comparison-row cost-comparison-neutral">
                    <span className="cost-comparison-label">Estate agent valuation</span>
                    <span className="cost-comparison-value">&euro;150 – &euro;300</span>
                </div>
                <div className="cost-comparison-row cost-comparison-good">
                    <span className="cost-comparison-label">HomeIndex Lifetime Access</span>
                    <span className="cost-comparison-value">&euro;19</span>
                </div>
                <a className="cost-comparison-source" href="/blog/posts/why-irish-buyers-overpay/" target="_blank" rel="noopener noreferrer"
                    onClick={() => posthog?.capture("blog_link_clicked", { source: "cost_comparison", post: "why-irish-buyers-overpay" })}>
                    Read the research →
                </a>
            </div>
        )
    }
}

export default CostComparison
